import React from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { FileUnderScanningMessage } from "constants/deal";

import { UploadStatus } from "./FilesUpload";

interface Props {
  filesNumber: number;
  uploadStatus: UploadStatus;
  isCloudMirror?: boolean;
}

export const Result: React.FC<Props> = ({ filesNumber, uploadStatus, isCloudMirror }) => {
  const isScanning = uploadStatus === "scanning";
  const isSuccess = uploadStatus === "success";
  const isError = uploadStatus === "error";

  const getProgressColor = () => {
    if (isSuccess) return "success";
    if (isError) return "error";
    if (isScanning) return "warning";
    return "primary";
  };

  const getMessage = () => {
    if (isError) return "Upload failed. Please try again.";
    if (isCloudMirror) {
      return isSuccess
        ? "Your files have been accepted. This may take some time. You'll see them in the cloud mirror once processing completes."
        : "Uploading files...";
    }
    if (isScanning) return FileUnderScanningMessage;
    if (isSuccess)
      return "AI processing will take a few minutes. You can wait or close the window. Altius will notify you when the process is complete. You can then continue working with Data Extractor.";
    return "Uploading files...";
  };

  return (
    <Stack sx={{ width: "100%", gap: "20px" }}>
      <Stack sx={{ flexDirection: "row", alignItems: "center", bgcolor: "#F6F8FC", gap: "10px", p: "10px" }}>
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 400,
            color: "#071f35",
            flexShrink: 0,
            whiteSpace: "nowrap"
          }}
        >
          {filesNumber} {filesNumber === 1 ? "file" : "files"}
        </Typography>
        <Stack sx={{ py: "10px", flexGrow: 1 }}>
          <LinearProgress
            color={getProgressColor()}
            variant={isSuccess || isError ? "determinate" : "indeterminate"}
            value={isSuccess || isError ? 100 : undefined}
          />
        </Stack>
        <Box sx={{ width: 24, height: 24 }}>{isSuccess && <DoneIcon sx={{ color: "#07A27D" }} />}</Box>
      </Stack>
      <Typography variant="body1">{getMessage()}</Typography>
    </Stack>
  );
};
